function openNav(element) {
    document.querySelector('.lemonly .off-canvas-slidebar').classList.add('open');
    document.querySelector('.lemonly .page-header-compact').classList.add('open');
    element.classList.add('open');
    element.setAttribute('aria-expanded', 'true');
    element.setAttribute('aria-label', 'Hide Menu');
}

function closeNav(element) {
    document.querySelector('.lemonly .off-canvas-slidebar').classList.remove('open');
    document.querySelector('.lemonly .page-header-compact').classList.remove('open');
    element.classList.remove('open');
    element.setAttribute('aria-label', 'Show Menu');
    element.setAttribute('aria-expanded', 'false');
}

if (document.querySelector('.lemonly .off-canvas-trigger')) {
    document.querySelector('.lemonly .off-canvas-trigger').addEventListener('click', function (event) {
        event.preventDefault();
        if (document.querySelector('.lemonly .off-canvas-trigger').classList.contains('open')) {
            closeNav(this);
        } else {
            openNav(this);
        }
    });
}